const map = {
	"./add-to-contacts.svg": "./src/icons/add-to-contacts.svg",
	"./ai-sparkle.svg": "./src/icons/ai-sparkle.svg",
	"./ai-template.svg": "./src/icons/ai-template.svg",
	"./archive-2.svg": "./src/icons/archive-2.svg",
	"./archive.svg": "./src/icons/archive.svg",
	"./asterisk.svg": "./src/icons/asterisk.svg",
	"./attach.svg": "./src/icons/attach.svg",
	"./audio.svg": "./src/icons/audio.svg",
	"./automate-processes.svg": "./src/icons/automate-processes.svg",
	"./automate.svg": "./src/icons/automate.svg",
	"./block-post.svg": "./src/icons/block-post.svg",
	"./block-user.svg": "./src/icons/block-user.svg",
	"./board-view.svg": "./src/icons/board-view.svg",
	"./brush.svg": "./src/icons/brush.svg",
	"./building.svg": "./src/icons/building.svg",
	"./buildings-group.svg": "./src/icons/buildings-group.svg",
	"./chat-unread.svg": "./src/icons/chat-unread.svg",
	"./chats.svg": "./src/icons/chats.svg",
	"./checkbox-selected.svg": "./src/icons/checkbox-selected.svg",
	"./checkmark.svg": "./src/icons/checkmark.svg",
	"./chevron-collapse.svg": "./src/icons/chevron-collapse.svg",
	"./chevron-expand.svg": "./src/icons/chevron-expand.svg",
	"./close.svg": "./src/icons/close.svg",
	"./closed-eye.svg": "./src/icons/closed-eye.svg",
	"./collapse.svg": "./src/icons/collapse.svg",
	"./comment-2.svg": "./src/icons/comment-2.svg",
	"./company.svg": "./src/icons/company.svg",
	"./configuration.svg": "./src/icons/configuration.svg",
	"./connection-failed.svg": "./src/icons/connection-failed.svg",
	"./contract.svg": "./src/icons/contract.svg",
	"./copy-1.svg": "./src/icons/copy-1.svg",
	"./copy.svg": "./src/icons/copy.svg",
	"./delete.svg": "./src/icons/delete.svg",
	"./dislike.svg": "./src/icons/dislike.svg",
	"./doc-splitting.svg": "./src/icons/doc-splitting.svg",
	"./doc.svg": "./src/icons/doc.svg",
	"./document.svg": "./src/icons/document.svg",
	"./done.svg": "./src/icons/done.svg",
	"./dot.svg": "./src/icons/dot.svg",
	"./double-check.svg": "./src/icons/double-check.svg",
	"./drag-and-drop.svg": "./src/icons/drag-and-drop.svg",
	"./dropdown.svg": "./src/icons/dropdown.svg",
	"./e-post-billing.svg": "./src/icons/e-post-billing.svg",
	"./edit.svg": "./src/icons/edit.svg",
	"./email-additional.svg": "./src/icons/email-additional.svg",
	"./email-copy.svg": "./src/icons/email-copy.svg",
	"./email-unread.svg": "./src/icons/email-unread.svg",
	"./email.svg": "./src/icons/email.svg",
	"./error.svg": "./src/icons/error.svg",
	"./expand.svg": "./src/icons/expand.svg",
	"./export.svg": "./src/icons/export.svg",
	"./external-request.svg": "./src/icons/external-request.svg",
	"./eye-filled.svg": "./src/icons/eye-filled.svg",
	"./faq.svg": "./src/icons/faq.svg",
	"./file.svg": "./src/icons/file.svg",
	"./filter-settings.svg": "./src/icons/filter-settings.svg",
	"./flat.svg": "./src/icons/flat.svg",
	"./folder-system.svg": "./src/icons/folder-system.svg",
	"./folder.svg": "./src/icons/folder.svg",
	"./forward.svg": "./src/icons/forward.svg",
	"./google-drive-2.svg": "./src/icons/google-drive-2.svg",
	"./hand.svg": "./src/icons/hand.svg",
	"./home-light.svg": "./src/icons/home-light.svg",
	"./image.svg": "./src/icons/image.svg",
	"./import-user-data.svg": "./src/icons/import-user-data.svg",
	"./info.svg": "./src/icons/info.svg",
	"./insurance.svg": "./src/icons/insurance.svg",
	"./integration.svg": "./src/icons/integration.svg",
	"./invoice.svg": "./src/icons/invoice.svg",
	"./label.svg": "./src/icons/label.svg",
	"./leave.svg": "./src/icons/leave.svg",
	"./like.svg": "./src/icons/like.svg",
	"./liked.svg": "./src/icons/liked.svg",
	"./link-1.svg": "./src/icons/link-1.svg",
	"./lock-1.svg": "./src/icons/lock-1.svg",
	"./lock-filled.svg": "./src/icons/lock-filled.svg",
	"./lock.svg": "./src/icons/lock.svg",
	"./logo-idwell.svg": "./src/icons/logo-idwell.svg",
	"./logo.svg": "./src/icons/logo.svg",
	"./map-pin.svg": "./src/icons/map-pin.svg",
	"./microphone-filled.svg": "./src/icons/microphone-filled.svg",
	"./minimize.svg": "./src/icons/minimize.svg",
	"./more-horizontal.svg": "./src/icons/more-horizontal.svg",
	"./more-vertical.svg": "./src/icons/more-vertical.svg",
	"./note-2.svg": "./src/icons/note-2.svg",
	"./note-email.svg": "./src/icons/note-email.svg",
	"./notification.svg": "./src/icons/notification.svg",
	"./offers.svg": "./src/icons/offers.svg",
	"./open-eye.svg": "./src/icons/open-eye.svg",
	"./open-in-new-window.svg": "./src/icons/open-in-new-window.svg",
	"./orders.svg": "./src/icons/orders.svg",
	"./outline-arrow-left.svg": "./src/icons/outline-arrow-left.svg",
	"./pdf.svg": "./src/icons/pdf.svg",
	"./phase-arrow-back.svg": "./src/icons/phase-arrow-back.svg",
	"./phase-arrow-front.svg": "./src/icons/phase-arrow-front.svg",
	"./phone.svg": "./src/icons/phone.svg",
	"./pin-filled.svg": "./src/icons/pin-filled.svg",
	"./pin.svg": "./src/icons/pin.svg",
	"./play.svg": "./src/icons/play.svg",
	"./plus.svg": "./src/icons/plus.svg",
	"./post.svg": "./src/icons/post.svg",
	"./ppt.svg": "./src/icons/ppt.svg",
	"./preview.svg": "./src/icons/preview.svg",
	"./print.svg": "./src/icons/print.svg",
	"./priority-filled.svg": "./src/icons/priority-filled.svg",
	"./priority.svg": "./src/icons/priority.svg",
	"./provider.svg": "./src/icons/provider.svg",
	"./providers.svg": "./src/icons/providers.svg",
	"./refresh.svg": "./src/icons/refresh.svg",
	"./related-sr.svg": "./src/icons/related-sr.svg",
	"./rental-portal.svg": "./src/icons/rental-portal.svg",
	"./reply-to-all.svg": "./src/icons/reply-to-all.svg",
	"./reply.svg": "./src/icons/reply.svg",
	"./report.svg": "./src/icons/report.svg",
	"./restore.svg": "./src/icons/restore.svg",
	"./rotate-left.svg": "./src/icons/rotate-left.svg",
	"./search.svg": "./src/icons/search.svg",
	"./service-request-connect.svg": "./src/icons/service-request-connect.svg",
	"./service-request-unread.svg": "./src/icons/service-request-unread.svg",
	"./service-request.svg": "./src/icons/service-request.svg",
	"./settings.svg": "./src/icons/settings.svg",
	"./share-2.svg": "./src/icons/share-2.svg",
	"./sorting-1.svg": "./src/icons/sorting-1.svg",
	"./sorting-down.svg": "./src/icons/sorting-down.svg",
	"./sorting-up.svg": "./src/icons/sorting-up.svg",
	"./sorting.svg": "./src/icons/sorting.svg",
	"./spinner.svg": "./src/icons/spinner.svg",
	"./star-filled.svg": "./src/icons/star-filled.svg",
	"./star.svg": "./src/icons/star.svg",
	"./statistic.svg": "./src/icons/statistic.svg",
	"./stop.svg": "./src/icons/stop.svg",
	"./switcher-right.svg": "./src/icons/switcher-right.svg",
	"./table-hide.svg": "./src/icons/table-hide.svg",
	"./table-open.svg": "./src/icons/table-open.svg",
	"./table-view.svg": "./src/icons/table-view.svg",
	"./task.svg": "./src/icons/task.svg",
	"./template.svg": "./src/icons/template.svg",
	"./text-long.svg": "./src/icons/text-long.svg",
	"./text-medium.svg": "./src/icons/text-medium.svg",
	"./text-short.svg": "./src/icons/text-short.svg",
	"./textarea-more.svg": "./src/icons/textarea-more.svg",
	"./translate.svg": "./src/icons/translate.svg",
	"./unblock-user.svg": "./src/icons/unblock-user.svg",
	"./upload-1.svg": "./src/icons/upload-1.svg",
	"./upload-2.svg": "./src/icons/upload-2.svg",
	"./user.svg": "./src/icons/user.svg",
	"./users-1.svg": "./src/icons/users-1.svg",
	"./video.svg": "./src/icons/video.svg",
	"./viewing.svg": "./src/icons/viewing.svg",
	"./vulcavo.svg": "./src/icons/vulcavo.svg",
	"./work.svg": "./src/icons/work.svg",
	"./workflow-bot.svg": "./src/icons/workflow-bot.svg",
	"./xls.svg": "./src/icons/xls.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons sync \\.svg$";